export default __webpack_public_path__ + "static/media/venues.04032c13.jpg";